export const status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  BOOTSTRAPPING: 'bootstrapping',
  BOOTSTRAPPED: 'bootstrapped',
  MOUNTING: 'mounting',
  MOUNTED: 'mounted',
  UPDATING: 'updating',
  UNMOUNTING: 'unmounting',
  UNLOADING: 'unloading',
  LOAD_ERROR: 'load-error',
  BOOTSTRAP_ERROR: 'bootstrap-error',
  MOUNT_ERROR: 'mount-error',
  UPDATE_ERROR: 'update-error',
  UNMOUNT_ERROR: 'unmount-error',
  UNLOAD_ERROR: 'unload-error',
};
